/**
 * 成員節點組件
 * 渲染單個成員，處理成員選擇
 */

import * as React from "react";
import { TreeItem, TreeItemLayout, Checkbox, makeStyles, tokens } from "@fluentui/react-components";
import { PersonRegular } from "@fluentui/react-icons";

const useStyles = makeStyles({
  memberItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 8px 8px 0",
    margin: "2px 0",
    borderRadius: "4px",
    transition: "all 0.2s ease",
    fontSize: "13px",
  },
  memberItemSelected: {
    backgroundColor: tokens.colorNeutralBackground4,
    borderLeft: `3px solid #0078D4`,
    transform: "translateX(0)",
    paddingLeft: "3px",
  },
  memberIcon: {
    color: "#0078D4",
    fontSize: "16px",
  },
  treeItemLayout: {
    paddingLeft: "0 !important",
    marginLeft: "0 !important",
  },
});

const MemberNode = ({ member, isSelected, isParentExpanded, level, onToggle }) => {
  const styles = useStyles();

  const handleClick = (e) => {
    // 如果點擊的是 checkbox 區域，阻止事件冒泡
    if (e.target.closest && (
      e.target.closest('input[type="checkbox"]') || 
      e.target.closest('[role="checkbox"]') ||
      e.target.closest('label')
    )) {
      e.stopPropagation();
    }
  };

  return (
    <TreeItem key={member.id} itemType="leaf">
      <TreeItemLayout
        className={styles.treeItemLayout}
        data-expanded={isParentExpanded ? "true" : "false"}
        data-level={level}
        onClick={handleClick}
        iconBefore={
          <Checkbox
            checked={isSelected}
            onChange={(e, data) => {
              e.stopPropagation();
              onToggle(member.id, data.checked);
            }}
            onClick={(e) => {
              e.stopPropagation();
            }}
          />
        }
      >
        <div 
          className={`${styles.memberItem} ${isSelected ? styles.memberItemSelected : ''}`}
          data-expanded={isParentExpanded ? "true" : "false"}
        >
          <PersonRegular className={styles.memberIcon} />
          <span>{member.displayName}</span>
        </div>
      </TreeItemLayout>
    </TreeItem>
  );
};

export default MemberNode;

